export const PERMISSION_LOOKUP_VERSION: number = 1;
export const BUSINESS_TICKETS_VERSION: number = 1;
export const ABSENCE_LETTER_VERSION: number = 1;
